import React, { MouseEventHandler } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { TFunction } from 'i18next'

import './ProjectMenu.scss'

import { ReactComponent as OpenPhotoIcon } from '../../assets/images/icons/i-open-photo.svg'
import IconButton from '../Common/Buttons/IconButton/IconButton'
import RevertControl from '../RevertControl/RevertControl'

interface ProjectMenuProps extends WithTranslation {
  openFileDialog: MouseEventHandler,
  t: TFunction
}

function ProjectMenu({ openFileDialog, t }: ProjectMenuProps) {
  return (
    <div className="project-menu">
      <div className="project-menu__item">
        <RevertControl />
      </div>
      <div className="project-menu__item">
        <IconButton
          onClick={openFileDialog}
          caption={t('buttons.open-photo')}
        >
          <OpenPhotoIcon />
        </IconButton>
      </div>
    </div>
  )
}

export default withTranslation()(ProjectMenu)
